var scope_0 = require('/Users/psoga/Documents/projects/ajb117.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0e7b7214a439d775e9fcf74eb9f733b2.js').default;
var scope_1 = require('/Users/psoga/Documents/projects/ajb117.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8670e7622b9632c68502fc12cc43f00b.js').default;
var scope_2 = require('/Users/psoga/Documents/projects/ajb117.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bd12554cb9a4798a41aec70f220c145e.js').default;
var scope_3 = require('/Users/psoga/Documents/projects/ajb117.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    